import classnames from 'classnames';
import { HTMLProps, JSX } from 'react';

import styles from './CircularLoader.module.scss';

export type CircularLoaderProps = Pick<HTMLProps<HTMLSpanElement>, 'className'>;

export default function CircularLoader({
  className,
}: CircularLoaderProps): JSX.Element {
  return <span className={classnames(styles.CircularLoader, className)} />;
}
